<template>
  <div class="pta-admin">
    <div class="page-titles border-bottom">
      <h3>General Partners
        <span class="card-subtitle" v-if="users">{{trans('general.total_result_found',{'count' : users.total})}}</span>
        <span class="card-subtitle" v-else>{{trans('general.no_result_found')}}</span>
     <!--   <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showCreatePanel && hasPermission('create-user')" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">{{trans('user.create_user')}}</span></button> -->
      </h3>
      <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @updateSortBy="value => {filterUserForm.sort_by = value}"  @updateOrder="value => {filterUserForm.order = value}"></sort-by>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
    </div>
    <div class="container-fluid p-20 pta-filter" style="font-size: 0.625em;">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <div class="card border-bottom" v-if="showFilterPanel">
              <div class="card-body p-4">
                <h4 class="card-title">{{trans('general.filter')}}</h4>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="name">{{trans('user.name')}}</label>
                      <input class="form-control" id="name" name="name" v-model="filterUserForm.name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="email">{{trans('user.email')}}</label>
                      <input class="form-control" id="email" name="email" v-model="filterUserForm.email">
                    </div>
                  </div>
                 <!-- <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="role_id">{{trans('role.role')}}</label>
                      <select v-model="filterUserForm.role_id" id="role_id" class="custom-select col-12">
                        <option value="">{{trans('general.select_one')}}</option>
                        <option v-for="role in roles" v-bind:value="role.id">
                          {{ role.name }}
                        </option>
                      </select>
                    </div>
                  </div> -->
                  <div class="col-6 col-sm-1">
                    <div class="form-group">
                      <label for="account_manager_id">Rep.</label>
                      <select v-model="filterUserForm.account_manager_id" id="account_manager_id" class="custom-select col-12">
                        <option value="">All</option>
                        <option value="1">Lawin</option>
                        <option value="2">Namo</option>
                        <option value="3">Sajith</option>
                        <option value="4">Tad</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-1">
                    <div class="form-group">
                      <label for="is_premium">Premium</label>
                      <select v-model="filterUserForm.is_premium" id="is_premium" class="custom-select col-12">
                        <option value="">All</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-1">
                    <div class="form-group">
                      <label for="sales_status_id">Outstanding</label>
                      <select v-model="filterUserForm.sales_status_id" id="sales_status_id" class="custom-select col-12">
                        <option value="">All</option>
                        <option value="99">Any</option>
                        <option value="3">Questionnaire</option>
                        <option value="4">Marketing Materials</option>
                        <option value="1">Intro Call</option>
                        <option value="2">Final Call</option>
                        <option value="5">LP list approval</option>
                        <option value="6">Campaign start</option>
                        <option value="7">Weekly LP list approval</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-1">
                    <div class="form-group">
                      <label for="status_id">GP Status</label>
                      <select v-model="filterUserForm.status_id" id="status_id" class="custom-select col-12">
                        <option value="">All</option>
                        <option value="1" style="color:#ffbc34">Open</option>
                        <option value="2" style="color:#029165">Won</option>
                        <option value="3" style="color:#950000">Lost</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-1">
                    <div class="form-group">
                      <label for="status">{{trans('user.status')}}</label>
                      <select v-model="filterUserForm.status" id="status" class="custom-select col-12">
                        <option value="">All</option>
                        <option value="activated">{{trans('user.status_activated')}}</option>
                        <option value="pending_activation">{{trans('user.status_pending_activation')}}</option>
                        <option value="pending_approval">{{trans('user.status_pending_approval')}}</option>
                        <option value="banned">{{trans('user.status_banned')}}</option>
                        <option value="disapproved">{{trans('user.status_disapproved')}}</option>
                      </select>
                    </div>
                  </div>
                 <!--  <div class="col-6 col-sm-6">
                    <div class="form-group">
                      <date-range-picker :start-date.sync="filterUserForm.created_at_start_date" :end-date.sync="filterUserForm.created_at_end_date" :label="trans('user.created_at')"></date-range-picker>
                    </div>
                  </div> -->
                </div>
                <button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
              </div>
            </div>
          </transition>
          <transition name="fade" v-if="hasPermission('create-user')">
            <div class="card border-bottom" v-if="showCreatePanel">
              <div class="card-body p-4">
                <!-- <h4 class="card-title">{{trans('user.add_new_user')}}</h4> -->
                <form @submit.prevent="submit" @keydown="userForm.errors.clear($event.target.name)" autocomplete="off">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="row">
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('user.first_name')}}</label>
                            <input class="form-control" type="text" value="" v-model="userForm.first_name" name="first_name" :placeholder="trans('user.first_name')">
                            <show-error :form-name="userForm" prop-name="first_name"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('user.last_name')}}</label>
                            <input class="form-control" type="text" value="" v-model="userForm.last_name" name="last_name" :placeholder="trans('user.last_name')" autocomplete="off">
                            <show-error :form-name="userForm" prop-name="last_name"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('user.password')}}</label>
                            <input class="form-control" type="password" value="" v-model="userForm.password" name="password" :placeholder="trans('user.password')" autocomplete="new-password">
                            <show-error :form-name="userForm" prop-name="password"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('user.password_confirmation')}}</label>
                            <input class="form-control" type="password" value="" v-model="userForm.password_confirmation" name="password_confirmation" :placeholder="trans('user.password_confirmation')">
                            <show-error :form-name="userForm" prop-name="password_confirmation"></show-error>
                          </div>
                        </div>
                        <div class="col-12 col-sm-3">
                          <div class="form-group">
                            <label for="">{{trans('user.email')}}</label>
                            <input class="form-control" type="text" value="" v-model="userForm.email" name="email" :placeholder="trans('user.email')" autocomplete="off">
                            <show-error :form-name="userForm" prop-name="email"></show-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                  <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                </form>
              </div>
            </div>
          </transition>
          <div class="card" v-if="users.total">
            <div class="card-body">
              <div class="table-responsive" v-if="hasPermission('list-user') && users.total">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th scope="col">Outstanding</th>
                    <th scope="col">Rep.</th>
                    <th scope="col">{{trans('user.first_name')}}</th>
                    <th scope="col">{{trans('user.last_name')}}</th>
                    <th scope="col">{{trans('user.email')}}</th>
                    <th scope="col">Premium</th>
                    <th scope="col">Last Login</th>
                    <th scope="col">Register Status</th>
                    <th scope="col" class="table-option">{{trans('general.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="user in users.data" v-if="user.profile">
                    <td :class="user.profile.status_id==2?'pta-status-won':(user.profile.status_id==3?'pta-status-lost':'pta-status-open')">
                      <span class="pta-os-label" v-if="user.profile.email_status==4 && user.profile.is_intro_call==0">Intro Call</span>
                      <span class="pta-os-label" v-if="user.profile.email_sales_status==8 && user.profile.is_final_call==0">Final Call</span>
                      <span class="pta-os-label" v-if="user.profile.is_premium_investors==1 && user.profile.is_confirmed==0">LP list approval</span>
                    </td>
                    <td v-text="(user.profile.account_manager_id==1)?'Lawin':(user.profile.account_manager_id==2?'Namo':(user.profile.account_manager_id==3?'Sajith':(user.profile.account_manager_id==4?'Tad':'-')))"></td>
                    <td v-if="user.profile" v-text="user.profile.first_name"></td><td v-else>-</td>
                    <td v-if="user.profile" v-text="user.profile.last_name"></td><td v-else>-</td>
                    <td v-text="user.email"></td>
                    <td v-if="user.profile" v-text="user.profile.is_premium?'Yes':'No'"></td><td v-else>-</td>
                    <td v-if="user.user_last_login">{{ user.user_last_login.created_at | momentTime }}</td><td v-else>-</td>
                    <td><span v-for="status in getUserStatus(user)" :class="['label','label-'+status.color,'m-r-5']">{{status.label}}</span></td>
                    <td class="table-option" v-if="user.profile">
                      <div class="btn-group">
                       <!--  <a :href="'/ps/'+user.id+'/pdf'" target="_blank" class="btn btn-info btn-sm" v-tooltip="'Presentation'"><i class="fas fa-file-alt"></i></a>
                        <a :href="'/account/users/general-partners/'+user.id+'/fact-sheet'" class="btn btn-info btn-sm" v-tooltip="'Fact Sheet'"><i class="fas fa-file-alt"></i></a>

                        <router-link v-if="user.investors.length" :to="`/account/users/general-partners/${user.id}/investors`" class="btn btn-inverse btn-sm" v-tooltip="'Investor List'"><i class="fas fa-user-group"></i></router-link>-->
                        <button v-if="user.investors.length && user.profile.is_confirmed==1" class="btn btn-info btn-sm" @click.prevent="showMessage(user.id)" v-tooltip="'Message preview'"><i class="fas fa-envelope"></i></button>
                        <router-link v-if="user.investors.length && user.profile.is_confirmed==1" :to="`/account/users/general-partners/${user.id}/campaign`" class="btn btn-info btn-sm" v-tooltip="'Campaign'"><i class="fas fa-bolt"></i></router-link>
                        <router-link :to="`/account/users/general-partners/${user.id}`" class="btn btn-edit btn-sm" v-tooltip="trans('user.view_user')"><i class="fas fa-arrow-circle-right"></i></router-link>
                        <button class="btn btn-danger btn-sm" :key="user.id" v-if="hasPermission('delete-user')" v-confirm="{ok: confirmDelete(user), message: 'Do you really want to delete the user?', okText: 'Delete', cancelText: 'Cancel'}" v-tooltip="trans('user.delete_user')"><i class="fas fa-trash"></i></button>
                      </div>
                    </td><td v-else></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--  <module-info v-if="!users.total" module="user" title="module_info_title" description="module_info_description" icon="users">
                    <div slot="btn">
                        <button class="btn btn-info btn-sm" v-if="hasPermission('create-user') && !showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> {{trans('general.add_new')}}</button>
                    </div>
                </module-info>
                 --><pagination-record :page-length.sync="filterUserForm.page_length" :records="users" @updateRecords="getUsers"></pagination-record>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modalMessage" class="modal fade">
      <div class="modal-dialog" style="max-width:920px;">
        <div class="modal-content">
          <div class="modal-header" style="display:block;">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
            <h4 id="modalTitle" class="modal-title">Message preview ({{ cur_message_name }})</h4>
          </div>
          <div id="modalBody" class="modal-body" style="font-size:18px;line-height:24px;"><!--   -->

            <div
                id='carouselExampleIndicators'
                class='carousel slide'
                data-ride='carousel'
            >
              <ol class='carousel-indicators'>
                <li
                    data-target='#carouselExampleIndicators'
                    data-slide-to='0'
                    class='active'
                    @click='onSlide(0)'
                ></li>
                <li
                    data-target='#carouselExampleIndicators'
                    data-slide-to='1'
                    @click='onSlide(1)'
                ></li>
                <li
                    data-target='#carouselExampleIndicators'
                    data-slide-to='2'
                    @click='onSlide(2)'
                ></li>
                <li
                    data-target='#carouselExampleIndicators'
                    data-slide-to='3'
                    @click='onSlide(3)'
                ></li>
                <li
                    data-target='#carouselExampleIndicators'
                    data-slide-to='4'
                    @click='onSlide(4)'
                ></li>
              </ol>
              <div class='carousel-inner' v-if="messages[0]">
                <div class='carousel-item active' v-html="messages[0].message"></div>
                <div class='carousel-item' v-html="messages[1].message"></div>
                <div class='carousel-item' v-html="messages[2].message"></div>
                <div class='carousel-item' v-html="messages[3].message"></div>
                <div class='carousel-item' v-html="messages[4].message"></div>
              </div>
              <a
                  class='carousel-control-prev'
                  href='#carouselExampleIndicators'
                  role='button'
                  data-slide='prev'
                  @click="onSlidePrev"
              >
                <span class='carousel-control-prev-icon' aria-hidden='true'></span>
                <span class='sr-only'>Previous</span>
              </a>
              <a
                  class='carousel-control-next'
                  href='#carouselExampleIndicators'
                  role='button'
                  data-slide='next'
                  @click="onSlideNext"
              >
                <span class='carousel-control-next-icon' aria-hidden='true'></span>
                <span class='sr-only'>Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import switches from 'vue-switches'
import vSelect from 'vue-multiselect'
import dateRangePicker from '../../components/date-range-picker'
import sortBy from '../../components/sort-by'

export default {
  components: {switches,vSelect,dateRangePicker,sortBy},
  data() {
    return {
      showCreatePanel: false,
      role_id: 2,
      users: {
        total: 0,
        data: []
      },
      filterUserForm: {
        name: '',
        email: '',
        role_id: 2,
        status: '',
        is_premium: 1,
        status_id: '',
        sales_status_id: '',
        account_manager_id: '',
        created_at_start_date: '',
        created_at_end_date: '',
        sort_by : 'first_name',
        order: 'asc',
        page_length: 100
      },
      userForm: new Form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role_id: [],
      }),
      countries: [],
      roles: [],
      selected_roles: '',
      message:'',
      messages:[],
      showFilterPanel: false,
      timeout: null,
      cur_slide: 0,
      cur_message_name: '',
      orderByOptions: [
        {
          value: 'first_name',
          translation: i18n.user.first_name
        },
        {
          value: 'last_name',
          translation: i18n.user.last_name
        },
        {
          value: 'email',
          translation: i18n.user.email
        },
        {
          value: 'status',
          translation: i18n.user.status
        },
        {
          value: 'created_at',
          translation: i18n.user.created_at
        },
        {
          value: 'last_login',
          translation: i18n.user.last_login
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/dashboard');
    }
    this.fetchPreRequisites();
    this.getUsers();
  },
  methods: {
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    onSlidePrev(slide){
      console.log("Prev");
      if(this.cur_slide==0){
        this.cur_slide = 4;
      }else{
        this.cur_slide--;
      }
      this.cur_message_name = this.messages[this.cur_slide].name;
    },
    onSlideNext(slide){
      console.log("Next");
      if(this.cur_slide==4){
        this.cur_slide = 0;
      }else{
        this.cur_slide++;
      }
      this.cur_message_name = this.messages[this.cur_slide].name;
    },
    onSlide(slide){
      this.cur_slide = slide;
      console.log("Slide: " + slide);
      this.cur_message_name = this.messages[slide].name;
    },
    showMessage(id){
      axios.get('/api/user/investor-messages/'+id+'/0')
          .then(response => response.data)
          .then(response => {
            this.messages = response.messages;
            this.cur_message_name = this.messages[0].name;
            $('#modalMessage').modal();
          })
          .catch(error => {
            helper.showDataErrorMsg(error);
          })
    },
    fetchPreRequisites(){
      axios.get('/api/user/pre-requisite')
          .then(response => response.data)
          .then(response => {
            this.countries = response.countries;
            this.roles = response.roles;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    onRoleSelect(selectedOption){
      this.userForm.errors.clear('role_id');
      this.userForm.role_id.push(selectedOption.id);
    },
    onRoleRemove(removedOption){
      this.userForm.role_id.splice(this.userForm.role_id.indexOf(removedOption.id), 1);
    },
    submit(){
      this.userForm.role_id = [ this.role_id ]
      if(this.role_id==5 || this.role_id==6){
        this.userForm.location_id = this.location_id
      }
      this.userForm.post('/api/user')
          .then(response => {
            toastr.success(response.message);
            this.selected_roles = null;
            this.selected_serviceseat_groups= null;
            this.selected_locations= null;
            this.userForm.role_id = [];
            this.userForm.location_ids = [];
            this.userForm.serviceseat_group_id = [];
            this.getUsers();
          })
          .catch(error => {
            helper.showErrorMsg(error);
          });
    },
    getUsers(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterUserForm);
      axios.get('/api/user?page=' + page + url)
          .then(response => response.data)
          .then(response => this.users = response)
          .catch(error => {
            helper.showDataErrorMsg(error);
          })
    },
    confirmDelete(user){
      return dialog => this.deleteUser(user);
    },
    deleteUser(user){
      axios.delete('/api/user/'+user.id)
          .then(response => response.data)
          .then(response => {
            toastr.success(response.message);
            this.getUsers();
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    getUserStatus(user){
      return helper.getUserStatus(user);
    },
    getAvatar(user){
      return helper.getAvatar(user);
    },
  },
  watch: {
    filterUserForm: {
      handler(val) {
        clearTimeout(this.timeout); // Lösche vorherigen Timer
        this.timeout = setTimeout(() => {
          this.getUsers(); // Aufruf nach Verzögerung
        }, 500); // Verzögerung in Millisekunden
      },
      deep: true,
    },
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    },
    momentTime(date) {
      return helper.formatDateTime(date);
    }
  }
}
</script>
<style>
.pta-status-won{
  border-left:8px solid #029165!important;
}
.pta-status-lost{
  border-left:8px solid #950000!important;
}
.pta-status-open{
  border-left:8px solid #ffbc34!important;
}
.pta-os-label{
  display:inline-block;
  background-color: #cccccc;
  color: #000000;
  padding: 5px 10px;
  line-height: 13px;
  font-weight: 400;
  border-radius: 4px;
  font-size: 55%;
  margin-right:5px;
}
</style>